Vendd.Scripts.load(function () {

    var $wrapper = $('.x-partner-list');

    if ($wrapper.length < 1)
        return;

    $wrapper.each(function () {
        var $partnerList = $(this);
        if ($partnerList.closest('.x-store-locator').length < 1) {
            var $boxes = $('.x-partner-box', $partnerList);
            initAccordion($boxes);

            if ($partnerList.hasClass('x-slider')) {
                var $sliderList = $(this);

                initSlider($sliderList);

                 $(window).resize($.debounce(500, function () {
                    initSlider($sliderList);
                }));

                $sliderList.on('destroy', function (event, slider, direction) {
                    initAccordion($boxes);
                });
            }
        }
    }); 

    function initAccordion($boxes) {    
        $boxes.on('click', '.js-info-toggle-btn', function (e) {
            var $this = $(this);
            var partner = $this.closest('.x-partner-box');
            var iconOpen = $this.data('open-icon');
            var iconClose = $this.data('close-icon');
            prevOpened = $this.closest('.x-partner-list').find('.x-partner-box.opened');
            if (!partner.hasClass('opened')) {
                prevOpened.find('.js-info-toggle-btn').toggleClass(iconOpen + ' ' + iconClose);
                prevOpened.removeClass('opened');
            }
            partner.toggleClass('opened');
            $this.toggleClass(iconOpen + ' ' + iconClose);
        });
    }

    function initSlider($sliderList) {
        if ($(window).outerWidth() < 480) {
            if ($sliderList.hasClass('swiper-initialized')) {
                sliderPartner.destroy(true, true);
            }
        } else {
            if (!$sliderList.hasClass('swiper-initialized')) {
                var sliderPartner = new Swiper($sliderList, {
                    slidesPerView: 2,
                    speed: 1000,
                    breakpoints: {
                        960: { slidesPerView: 4 },
                        768: { slidesPerView: 3 },
                        480: { slidesPerView: 2 }
                    }
                });
            }
        }
    }

});